export const getApiProxyUrl = (fallback = null) => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/crm`;
  }

  return fallback;
};
